

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Poly } from '@/dto/polygon/poly';

@Injectable({ providedIn: 'root' })
export class ReseauService {
  constructor(private http: HttpClient) {
  }

  getInsidePoly(poly: Poly): Observable<any> {
    return this.http.post(environment.apiUrl + '/dashboard/insidepoly', poly, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(val => val);
  }

}
